import React from 'react';
import ActionButton from '../buttons/action-button';

const BillingPlan = ({name, code, price, isCurrentPlan, features, onSelectPlanClicked, errorHandler}) => {

  return <div className="col-12 col-md-3">
    <div className="card" style={{height: '100%'}}>
      <div className="card-header text-center">
        <h4>{name}</h4>
        {price}
      </div>
      <div className="card-body position-relative">
        <ul>
          {features.map((feature, i) => <li key={i} className="mb-2">
            <span dangerouslySetInnerHTML={{__html: feature}}/>
          </li>)}
        </ul>
        <div>
          <div style={{height: '50px'}}/>
          <div className="position-absolute bottom-0 w-100" style={{left: 0}}>
            <div className="row justify-content-center mb-3">
              <div className="col-auto">
                {isCurrentPlan ?
                  <button className="btn btn-secondary px-5" disabled>
                    Current plan
                  </button> :
                  <ActionButton className="btn-success px-5"
                                action={() => onSelectPlanClicked(code)}
                                errorHandler={errorHandler}>
                    Select plan
                  </ActionButton>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
};

export default BillingPlan;
